import { maskValueShape } from '@1trading/ts-common/utils';
import { captureMessage } from '@sentry/react';

// Longer than any NCI or TIN, and keeps the shape inside Sentry's 200-character tag limit
const MAX_REPORTED_IDENTIFIER_LENGTH = 64;

type InvalidIdentifierMessage = 'NCI_VALIDATION_FAILED' | 'TIN_VALIDATION_FAILED';

type InvalidIdentifier = {
  country: string;
  identifier: string;
  identifierType?: string;
};

/** Reports an identifier that failed its format check by its masked shape, so the value itself never reaches Sentry. */
export const reportInvalidIdentifier = (message: InvalidIdentifierMessage, { country, identifier, identifierType }: InvalidIdentifier) => {
  captureMessage(message, {
    level: 'warning',
    tags: {
      country,
      ...(identifierType && { identifier_type: identifierType }),
      shape: maskValueShape(identifier.slice(0, MAX_REPORTED_IDENTIFIER_LENGTH)),
    },
  });
};
